import { Flex } from '@gmg/gmg-react-components';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import WrappedSpinner from 'src/shared/WrappedSpinner';

interface LoadingPageProps { };

// This component is designed to display a loading indicator while gathering necessary information
// before redirecting the user to a protected route within the application.
const LoadingPage: FunctionComponent<LoadingPageProps> = () => {
    const { t } = useTranslation();

    return (
        <Flex alignItems="center" justifyContent="center" height="100vh">
            <WrappedSpinner label={t('Common.Spinner', 'Loading...')} labelPosition="bottom" />
        </Flex>
    );
};


export default LoadingPage;